import api from '../../../api';
import { ResponseSuccess } from '../../../shared/types';
import {
  AddEmailFromCSVRequestPayload,
  DownloadEmailVerifiedFilePayload,
  GetUploadedFilePayload,
  VerifyEmailRequestPayload,
} from '../types';

export const verifyEmail = async (payload: VerifyEmailRequestPayload) =>
  api.post<ResponseSuccess>(`/email-verifier/verify`, payload);

export const emailVerifierUploadedFilesList = async (
  payload: GetUploadedFilePayload,
) => {
  const { cancelToken, ...params } = payload;
  return api.get<ResponseSuccess>(`/email-verifier/`, { params, cancelToken });
};

export const getUploadedFileByCsv = async ({
  file,
  mapConfig,
  totalRecords,
}: AddEmailFromCSVRequestPayload) => {
  const data = new FormData();
  data.append('file', file);
  data.append('mapConfig', JSON.stringify(mapConfig));
  data.append('totalRecords', totalRecords?.toString());
  return api.post<ResponseSuccess>(`/email-verifier/upload`, data);
};

export const downloadEmailVerifiedFile = async (
  payload: DownloadEmailVerifiedFilePayload,
) => api.post<ResponseSuccess>(`/email-verifier/export`, payload);


export const getVerifiedEmailFileDetailsById = async (id: number) =>
  api.get<ResponseSuccess>(`/email-verifier/status?emailVerificationId=${id}`);